import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\TagController::store
* @see app/Http/Controllers/Creator/TagController.php:19
* @route '/app/creator/campaigns/tags'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns/tags',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\TagController::store
* @see app/Http/Controllers/Creator/TagController.php:19
* @route '/app/creator/campaigns/tags'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\TagController::store
* @see app/Http/Controllers/Creator/TagController.php:19
* @route '/app/creator/campaigns/tags'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TagController::store
* @see app/Http/Controllers/Creator/TagController.php:19
* @route '/app/creator/campaigns/tags'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TagController::store
* @see app/Http/Controllers/Creator/TagController.php:19
* @route '/app/creator/campaigns/tags'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Creator\TagController::update
* @see app/Http/Controllers/Creator/TagController.php:38
* @route '/app/creator/campaigns/tags/{tag}'
*/
export const update = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/app/creator/campaigns/tags/{tag}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Creator\TagController::update
* @see app/Http/Controllers/Creator/TagController.php:38
* @route '/app/creator/campaigns/tags/{tag}'
*/
update.url = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { tag: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { tag: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            tag: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        tag: typeof args.tag === 'object'
        ? args.tag.uuid
        : args.tag,
    }

    return update.definition.url
            .replace('{tag}', parsedArgs.tag.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\TagController::update
* @see app/Http/Controllers/Creator/TagController.php:38
* @route '/app/creator/campaigns/tags/{tag}'
*/
update.put = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Creator\TagController::update
* @see app/Http/Controllers/Creator/TagController.php:38
* @route '/app/creator/campaigns/tags/{tag}'
*/
const updateForm = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TagController::update
* @see app/Http/Controllers/Creator/TagController.php:38
* @route '/app/creator/campaigns/tags/{tag}'
*/
updateForm.put = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Creator\TagController::destroy
* @see app/Http/Controllers/Creator/TagController.php:58
* @route '/app/creator/campaigns/tags/{tag}'
*/
export const destroy = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/creator/campaigns/tags/{tag}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Creator\TagController::destroy
* @see app/Http/Controllers/Creator/TagController.php:58
* @route '/app/creator/campaigns/tags/{tag}'
*/
destroy.url = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { tag: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { tag: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            tag: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        tag: typeof args.tag === 'object'
        ? args.tag.uuid
        : args.tag,
    }

    return destroy.definition.url
            .replace('{tag}', parsedArgs.tag.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\TagController::destroy
* @see app/Http/Controllers/Creator/TagController.php:58
* @route '/app/creator/campaigns/tags/{tag}'
*/
destroy.delete = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Creator\TagController::destroy
* @see app/Http/Controllers/Creator/TagController.php:58
* @route '/app/creator/campaigns/tags/{tag}'
*/
const destroyForm = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TagController::destroy
* @see app/Http/Controllers/Creator/TagController.php:58
* @route '/app/creator/campaigns/tags/{tag}'
*/
destroyForm.delete = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Creator\TagController::assign
* @see app/Http/Controllers/Creator/TagController.php:83
* @route '/app/creator/campaigns/tags/{tag}/assign'
*/
export const assign = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: assign.url(args, options),
    method: 'post',
})

assign.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns/tags/{tag}/assign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\TagController::assign
* @see app/Http/Controllers/Creator/TagController.php:83
* @route '/app/creator/campaigns/tags/{tag}/assign'
*/
assign.url = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { tag: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { tag: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            tag: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        tag: typeof args.tag === 'object'
        ? args.tag.uuid
        : args.tag,
    }

    return assign.definition.url
            .replace('{tag}', parsedArgs.tag.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\TagController::assign
* @see app/Http/Controllers/Creator/TagController.php:83
* @route '/app/creator/campaigns/tags/{tag}/assign'
*/
assign.post = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: assign.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TagController::assign
* @see app/Http/Controllers/Creator/TagController.php:83
* @route '/app/creator/campaigns/tags/{tag}/assign'
*/
const assignForm = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: assign.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TagController::assign
* @see app/Http/Controllers/Creator/TagController.php:83
* @route '/app/creator/campaigns/tags/{tag}/assign'
*/
assignForm.post = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: assign.url(args, options),
    method: 'post',
})

assign.form = assignForm

/**
* @see \App\Http\Controllers\Creator\TagController::unassign
* @see app/Http/Controllers/Creator/TagController.php:110
* @route '/app/creator/campaigns/tags/{tag}/unassign'
*/
export const unassign = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unassign.url(args, options),
    method: 'post',
})

unassign.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns/tags/{tag}/unassign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\TagController::unassign
* @see app/Http/Controllers/Creator/TagController.php:110
* @route '/app/creator/campaigns/tags/{tag}/unassign'
*/
unassign.url = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { tag: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { tag: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            tag: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        tag: typeof args.tag === 'object'
        ? args.tag.uuid
        : args.tag,
    }

    return unassign.definition.url
            .replace('{tag}', parsedArgs.tag.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\TagController::unassign
* @see app/Http/Controllers/Creator/TagController.php:110
* @route '/app/creator/campaigns/tags/{tag}/unassign'
*/
unassign.post = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unassign.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TagController::unassign
* @see app/Http/Controllers/Creator/TagController.php:110
* @route '/app/creator/campaigns/tags/{tag}/unassign'
*/
const unassignForm = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unassign.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TagController::unassign
* @see app/Http/Controllers/Creator/TagController.php:110
* @route '/app/creator/campaigns/tags/{tag}/unassign'
*/
unassignForm.post = (args: { tag: string | { uuid: string } } | [tag: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unassign.url(args, options),
    method: 'post',
})

unassign.form = unassignForm

const tags = {
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    assign: Object.assign(assign, assign),
    unassign: Object.assign(unassign, unassign),
}

export default tags